import { RouteConfig } from '@app/types';
import { PageContent } from '../page-content';
import { NavMenu } from './NavMenu';
import { NavRoutes } from './NavRoutes';

type NavLayoutProps<TPath extends string> = {
  /** Route to redirect to when the current path matches no config. */
  defaultRoute: TPath;
  routes: RouteConfig<TPath>[];
  /** Optional class for a wrapper around the routed content. */
  contentClassName?: string;
};

/** Nav menu + routed page content shell shared by config-driven layouts. */
export function NavLayout<TPath extends string>({
  contentClassName,
  defaultRoute,
  routes
}: NavLayoutProps<TPath>) {
  const content = <NavRoutes defaultRoute={defaultRoute} routes={routes} />;

  return (
    <>
      <NavMenu routes={routes} />
      <PageContent>
        {(!contentClassName) ? content : (
          <div className={contentClassName}>{content}</div>
        )}
      </PageContent>
    </>
  );
}
